export enum TrendTypes {
  PERCENT = 'percent',
  NUMBER = 'number',
  POINT = 'point',
}

export type TrendType = `${TrendTypes}`
